import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IrArribaComponent } from '../body/ir-arriba/ir-arriba.component';
import { CarrucelComponent } from '../body/carrucel/carrucel.component';
import { RecientesComponent } from '../body/recientes/recientes.component';
import { AsignaturasComponent } from '../body/asignaturas/asignaturas.component';
import { GradosComponent } from '../body/grados/grados.component';
import { ActividadesFiltradasComponent } from '../body/actividades-filtradas/actividades-filtradas.component';
import { FiltrosComponent } from '../body/filtros/filtros.component';
import { CargarConfService } from '../../services/cargar-conf.service';
import { ListadoDinamicoComponent } from '../body/listado-dinamico/listado-dinamico.component';
import { Toast } from 'primeng/toast';
import { HeaderKrismarComponent } from '../headers/header-krismar/header-krismar.component';
import { LoginPageComponent } from '../../auth/pages/login-page/login-page.component';
import { FooterKrismarComponent } from '../footers/footer-krismar/footer-krismar.component';

@Component({
    selector: 'app-template',
    imports: [CommonModule,
        RouterModule,
        HeaderKrismarComponent,
        CarrucelComponent,
        RecientesComponent,
        AsignaturasComponent,
        GradosComponent,
        FiltrosComponent,
        ActividadesFiltradasComponent,
        IrArribaComponent,
        FooterKrismarComponent,
        ListadoDinamicoComponent,
        Toast,
        LoginPageComponent
    ],
    templateUrl: './template.component.html',
    styleUrl: './template.component.css'
})
export class TemplateComponent {


    public mostrar: boolean = false;
    // Variables temporales para mostrar los componenetes de carrucel, asignaturas y grados
    public mostrarPrincipal: boolean = true;

    public mostrarSecundario: boolean = false;

    public _conf = inject(CargarConfService);

    get viewCarrucel(): boolean {
        return (this._conf.getCurrentFilters().class_asignatura !== null || this._conf.getCurrentFilters().grado !== null);
    }

    get viewComponentes(): boolean {
        return this._conf.getCurrentFilters().class_asignatura !== null && this._conf.getCurrentFilters().grado !== null;
    }

    get viewRecientes(): boolean {
        // console.debug('View Recientes:', this._conf.recientes.length > 0 && (this._conf.getCurrentFilters().asignatura === null && this._conf.getCurrentFilters().grado === null));
        // console.debug(this._conf.getCurrentFilters());
        return this._conf.recientes.length > 0 && (this._conf.getCurrentFilters().asignatura === null && this._conf.getCurrentFilters().grado === null && this._conf.getCurrentFilters().class_asignatura === null);
    }

    get existenDatos(): boolean {
        return (this._conf.dataGlobal?.asignaturas?.length ?? 0) > 0
            || (this._conf.dataGlobal?.grados?.length ?? 0) > 0;
    }

    get viewAsignaturas(): boolean {
        return (this._conf.dataGlobal?.asignaturas?.length ?? 0) > 1;
    }

    get viewGrados(): boolean {
        return (this._conf.dataGlobal?.grados?.length ?? 0) > 1;
    }
}
